import { defineMessages } from '@redbubble/next/intl';

export const styleSwitchMessages = defineMessages({
  exploreMore: { defaultMessage: 'Explore more styles' },
  style: { defaultMessage: 'Style' },
  title: { defaultMessage: 'Explore more styles' },
  popularStyles: { defaultMessage: 'Popular' },
  moreStyles: { defaultMessage: 'More styles' },
  loadMoreStyles: { defaultMessage: `Load {count} more` },
  alsoAvailableOnTextLink: {
    defaultMessage: `View +{count} more products with this design`,
  },
});

export const longStyleDescriptions = defineMessages({
  // tshirts
  'sooky-sanga': {
    defaultMessage: 'Best-seller soft tee, crew neck, regular fit',
  },
  'unreal-chinwag': {
    defaultMessage: 'Super soft tee, crew neck, regular fit',
  },
  'cactus-bizzo': { defaultMessage: 'Everyday tee, crew neck, generous fit' },
  'cluey-kookaburra': { defaultMessage: 'Everyday tee, crew neck, slim fit' },
  'ripper-rissole': { defaultMessage: 'Soft tee, crew neck, regular fit' },
  'flaming-ute': { defaultMessage: 'Comfy tee, wide scoop neck, boxy fit' },
  'outback-brolly': {
    defaultMessage: 'Long sleeve soft tee, crew neck, slim fit',
  },
  'chrissy-chungus': {
    defaultMessage: 'Sport-friendly stretch tee, crew neck, regular fit',
  },
  'grouse-chips': {
    defaultMessage: 'Raglan baseball tee, crew neck, regular fit',
  },
  'shouty-pav': {
    defaultMessage: 'Racerback tank, crew neck, form-fitting fit',
  },
  'tall-larrikin': { defaultMessage: 'Everyday tank, crew neck, slim fit' },
  'dinkum-bandicoot': { defaultMessage: 'Fitted top, scoop neck, slim fit' },
  'wonky-mozzie': { defaultMessage: 'Fitted top, crew neck, slim fit' },
  'peckish-flannel': { defaultMessage: 'Fitted top, v-neck, slim fit' },
  'cheeky-cockatoo': { defaultMessage: 'Lightweight tee, v-neck, regular fit' },
  'billowing-parachute': {
    defaultMessage: 'Heavyweight tee, crewneck, oversized fit',
  },
  'blockish-wrapper': {
    defaultMessage: 'Elevated comfy tee, crew neck, boxy fit',
  },
  'calm-wrapper': { defaultMessage: 'Relaxed tee, crewneck, draped fit' },

  // hoodies
  'whinging-magpie': {
    defaultMessage: 'Soft hoodie, french terry, front pouch',
  },
  'fair-cuppa': {
    defaultMessage: 'Best-seller pullover, cozy fleece, front pouch',
  },
  'aggro-emu': {
    defaultMessage: 'Everyday sweatshirt, french terry, raglan sleeve',
  },
  'jumping-boot': { defaultMessage: 'Classic pullover, cozy fleece, crewneck' },
  'bonza-lamington': {
    defaultMessage: 'Full-zip hoodie, cozy fleece, front pouch',
  },
  'billowing-falsehood': {
    defaultMessage: 'Premium pullover, heavyweight fleece, roomy sleeves',
  },
  'billowing-swelter': {
    defaultMessage: 'Premium sweatshirt, heavyweight fleece, roomy sleeves',
  },

  // wall art
  'shifting-brolly': {
    defaultMessage: 'Textured watercolor paper on art board',
  },
  'strewn-joey': { defaultMessage: 'Gallery-grade paper, high-quality print' },
  'outback-mate': { defaultMessage: 'Stretched canvas over wooden frame' },
  'googy-veggies': {
    defaultMessage: 'Gallery-grade prints with choice of wood frame',
  },
  'fair-garage': {
    defaultMessage: 'Photo paper with luster or metallic finish',
  },
  'beaut-flannel': { defaultMessage: 'Heavy poster paper, semigloss finish' },
  'shouty-flannel': { defaultMessage: 'Lightweight polyester in large sizes' },
});
